import type { TranslationKey } from "@privacy/translations";
import type { InputType } from "../../../dynamicForm";
import { logError } from "../../../api/logError";

export const getInputTypeInfo = (inputType: InputType) => {
  const map: Record<InputType, { textKey: TranslationKey }> = {
    textInput: { textKey: "Template.QuestionType.Text" },
    multipleChoiceInput: { textKey: "Template.QuestionType.MultiChoice" },
    dynamicMultipleChoiceInput: { textKey: "Template.QuestionType.MultiChoice" },
    singleChoiceInput: { textKey: "Template.QuestionType.SingleChoice" },
    yesOrNoInput: { textKey: "Template.QuestionType.YesOrNo" },
    systemInput: { textKey: "Template.QuestionType.System" },
    emailInput: { textKey: "Template.QuestionType.Email" },
    phoneNumberInput: { textKey: "Template.QuestionType.PhoneNumber" },
    personInput: { textKey: "Template.QuestionType.Person" },
    multiplePersonInput: { textKey: "Template.QuestionType.multiplePersonInput" },
    countryInput: { textKey: "Template.QuestionType.MultiChoice" },
    dateInput: { textKey: "Template.QuestionType.dateInput" },
    measureInput: { textKey: "Template.QuestionType.measureInput" },
    singleDpiaInput: { textKey: "Template.QuestionType.measureInput" },
    multipleTenantInput: { textKey: "Template.QuestionType.MultiTenantInput" },
    multipleExternalLinkInput: { textKey: "Template.QuestionType.Links" },
    multiplePartnerInput: { textKey: "Template.QuestionType.MultiplePartnerInput" },
    externalLinkInput: { textKey: "Template.QuestionType.Link" },
    multipleContactPersonInput: { textKey: "Template.QuestionType.multipleContactPersonInput" },
    multipleSubSupplierInput: { textKey: "Template.QuestionType.multipleSubSupplierInput" },
  };

  const result = map[inputType];
  if (!result) {
    logError(`Input type ${inputType} not found`);
    return null;
  }
  return result;
};

export const DIALOG_HEADER_HEIGHT = "72px";
export const DIALOG_FOOTER_HEIGHT = "74px";
